const preferenceCache = new Map();
let cacheVersion = 0;

export const DEFAULT_CHANNEL_PREFERENCES = {
  communicationTypes: {
    accountNotifications: true,
    marketingCommunications: false,
  },
  preferredChannels: {
    email: true,
    sms: true,
    phone: false,
    physicalMail: false,
  },
};

export const getChannelPreferenceCacheKey = (debtIdentifier) =>
  debtIdentifier ? String(debtIdentifier) : null;

export const getChannelPreferenceCacheVersion = () => cacheVersion;

export const getCachedChannelPreferences = (debtIdentifier) => {
  const cacheKey = getChannelPreferenceCacheKey(debtIdentifier);
  return cacheKey ? preferenceCache.get(cacheKey) || null : null;
};

export const preferencesFromChannelPreferenceSnapshot = (snapshot) => {
  if (!snapshot) return DEFAULT_CHANNEL_PREFERENCES;

  return {
    communicationTypes: {
      accountNotifications: Boolean(snapshot.accountNotificationsPreferred),
      marketingCommunications: Boolean(snapshot.marketingCommunicationsPreferred),
    },
    preferredChannels: {
      email: Boolean(snapshot.channelEmailPreferred),
      sms: Boolean(snapshot.channelSmsPreferred),
      phone: Boolean(snapshot.channelPhonePreferred),
      physicalMail: Boolean(snapshot.channelPhysicalMailPreferred),
    },
  };
};

export const setCachedChannelPreferences = (
  debtIdentifier,
  preferences,
  expectedCacheVersion = cacheVersion
) => {
  const cacheKey = getChannelPreferenceCacheKey(debtIdentifier);
  if (!cacheKey) return;
  if (expectedCacheVersion !== cacheVersion) return;
  preferenceCache.set(cacheKey, preferences);
};

export const deleteCachedChannelPreferences = (debtIdentifier) => {
  const cacheKey = getChannelPreferenceCacheKey(debtIdentifier);
  if (!cacheKey) return;
  preferenceCache.delete(cacheKey);
};

export const clearChannelPreferenceCache = () => {
  cacheVersion += 1;
  preferenceCache.clear();
};
